module.exports = __webpack_public_path__ + "img/sum-grey.ea48a2f1.svg";